import React, { useState } from "react";
import { Button, Form } from "reactstrap";
import * as Scrivito from "scrivito";
import { useTranslate } from "hooks";
import { countries } from "variables";
import { Select } from "components/Select/Select";
import { Icon } from "components";
import { getPageLink, getURLForSelectCountry } from "utils";

export const SelectLanguageView = Scrivito.connect(({ page }) => {
  const translate = useTranslate();
  const pageParams = Scrivito.currentPageParams() || { view: "login" };

  const [currentOption, setCurrentOption] = useState(null);

  const handleCountryChange = (option) => {
    setCurrentOption(option);
  };

  const translatedCountries = countries.map((item) => ({
    ...item,
    label: translate(item.translationKey),
  }));

  const { view } = pageParams;

  const resetPasswordLink =
    getPageLink(page.get("loginResetLink")) || Scrivito.currentPage();
  const loginNewAccountLink =
    getPageLink(page.get("loginNewAccountLink")) || Scrivito.currentPage();

  const redirectLinkObj =
    view === "forgotPass" ? resetPasswordLink : loginNewAccountLink;

  const newUrl = getURLForSelectCountry({
    value: currentOption?.value,
    view,
    obj: redirectLinkObj,
  });

  const newLink = redirectLinkObj.copy({
    url: newUrl,
  });

  const formTitle =
    view === "forgotPass"
      ? translate("SELECT_LANGUAGE_VIEW_PASSWORD_RESET")
      : translate("SELECT_LANGUAGE_VIEW_REGISTRATION");

  return (
    <Form
      className="bg-white col-md-6 mx-auto p-0 d-flex flex-column"
      data-testid="select-lang-view"
    >
      <div className="p-4 font-size-md">
        <Scrivito.LinkTag
          data-testid="SelectLangView_login-page-link"
          className="text-secondary d-flex align-items-center"
          to={page}
          params={{ view: "login" }}
        >
          <Icon
            prefix="trox"
            iconName="chevron-left-regular"
            className="me-1"
          />
          <span>{translate("RESET_VIEW_BACK_TO_LOGIN_BUTTON")}</span>
        </Scrivito.LinkTag>
      </div>
      <div className="col-md-11 mx-auto text-center">
        <h2>{formTitle}</h2>
        <div className="w-75 mx-auto mt-6">
          <p>{translate("COUNTRY")}</p>
          <Select
            testId="SelectLangView_lang-select"
            options={translatedCountries}
            value={currentOption}
            onChange={handleCountryChange}
            wrapperClassNames="w-100"
          />
          <div className="text-end mt-5 mb-6">
            <Button
              data-testid="SelectLangView_next-btn"
              onClick={() => {
                Scrivito.navigateTo(newLink);
              }}
              disabled={!currentOption}
              type="submit"
              color="primary"
            >
              {translate("NEXT_BUTTON")}
            </Button>
          </div>
        </div>
      </div>
    </Form>
  );
});
